/* =====================================================================
   q859 (2 Nov 2026): NOW A COMPACT BOTTOM BANNER - see build() below.
   × = accept all; Reject all lives under Customise. Harley's decision,
   KB 0aa5b516d6a44405; the 14 Sept notes below describe the old modal
   and are kept for the history of WHY it was built that way.
   ===================================================================== */
/* =====================================================================
   HL LONDON - CONSENT GATE (q403 Phase 3, restructured 14 Sept 2026)

   THE HIERARCHY, AND WHY IT IS DEFENSIBLE
   ---------------------------------------
   Two primary buttons: ACCEPT (filled espresso, the obvious press) and
   CUSTOMISE (outline, same size, quieter). BELOW them, a plain
   underlined text link: REJECT.

   Rejecting is ONE CLICK from the first screen, exactly like accepting.
   It is never moved behind Customise and never costs an extra step. The
   link is set at the body type scale in espresso on ivory (13.6:1) with
   a 44px tap target, so it is genuinely readable rather than nominally
   present. If you are tempted to shrink it, grey it, or push it behind
   the preferences step: that is the change that makes this indefensible
   under UK GDPR / PECR. Do not.

   IT DRIVES ANALYZELY, IT DOES NOT REPLACE IT.
   Measured on the live theme, 14 Sept 2026:
     - Analyzely's app embed renders ONLY two buttons, Accept and
       Decline. It has NO granular preferences panel of any kind, so
       the Customise panel below is ours by necessity, not by choice.
     - Clicking either of its buttons hides its wrapper permanently
       (display:none, and it stays hidden across reloads).
     - Shopify.customerPrivacy.setTrackingConsent() writes per-category
       consent that persists across reloads, and a write made AFTER
       Analyzely's own click survives intact.
   So: every path clicks one of Analyzely's buttons to retire its bar,
   then writes the precise consent through Shopify's API, which is the
   canonical store the pixels actually read.

   CRAWLERS. The page HTML is complete before this runs - the gate is an
   extra fixed layer, not a replacement for the document - so a crawler
   that reads HTML is unaffected. For crawlers that RENDER, the gate is
   skipped outright on a known bot user agent, so Googlebot sees pages.

   HONEST LIMIT: this is JavaScript. With JS disabled there is no gate,
   and no Analyzely banner either. No theme-side gate can be otherwise.
   ===================================================================== */
(function () {
  'use strict';

  var STORE_KEY = 'hl_consent_choice_v1';
  var CATS_KEY  = 'hl_consent_cats_v1';
  var BOT = /bot|crawl|spider|slurp|bingpreview|headlesschrome|lighthouse|gtmetrix|pingdom|ahrefs|semrush|facebookexternalhit|embedly|whatsapp|telegram|applebot|duckduckbot|baiduspider|yandex|petalbot|google-inspectiontool/i;

  if (BOT.test(navigator.userAgent || '')) return;

  /* ---- has the visitor already decided? ------------------------------ */
  function storedChoice() {
    try {
      var v = window.localStorage.getItem(STORE_KEY);
      if (v === 'accept' || v === 'reject' || v === 'custom') return v;
    } catch (e) { /* private mode */ }
    var m = document.cookie.match(new RegExp('(?:^|; )' + STORE_KEY + '=(accept|reject|custom)'));
    return m ? m[1] : null;
  }

  function shopifyDecided() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      var c = cp && cp.currentVisitorConsent && cp.currentVisitorConsent();
      if (!c) return false;
      /* Shopify returns '' for "not asked" and yes/no once answered. */
      return (c.analytics === 'yes' || c.analytics === 'no' ||
              c.marketing === 'yes' || c.marketing === 'no');
    } catch (e) { return false; }
  }

  function remember(choice, cats) {
    var a = new Date();
    a.setFullYear(a.getFullYear() + 1);
    try {
      window.localStorage.setItem(STORE_KEY, choice);
      if (cats) window.localStorage.setItem(CATS_KEY, JSON.stringify(cats));
    } catch (e) {}
    document.cookie = STORE_KEY + '=' + choice + '; path=/; expires=' + a.toUTCString() + '; SameSite=Lax';
  }

  /* ---- write the decision through every channel we have ---------------
     Order matters and was measured: Analyzely's button FIRST (it retires
     its own bar and writes an all-or-nothing baseline), our precise
     per-category write SECOND, because the later write is the one that
     sticks. Reversing these loses a mixed selection. */
  function record(choice, cats) {
    var allOn = choice === 'accept';
    cats = cats || {
      analytics: allOn, marketing: allOn,
      preferences: allOn, sale_of_data: allOn
    };

    /* 1. retire the app's own bar for good */
    var btn = document.getElementById(
      (choice === 'accept')
        ? 'analyzely-consent-banner__accept-button'
        : 'analyzely-consent-banner__decline-button');
    if (btn) { try { btn.click(); } catch (e) {} }

    /* 2. the precise per-category truth, which Shopify's pixels read */
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && cp.setTrackingConsent) {
        cp.setTrackingConsent({
          analytics:    !!cats.analytics,
          marketing:    !!cats.marketing,
          preferences:  !!cats.preferences,
          sale_of_data: !!cats.sale_of_data
        }, function () {});
      }
    } catch (e) {}

    remember(choice, cats);
  }

  if (storedChoice() || shopifyDecided()) return;

  /* ---- build it -------------------------------------------------------
     q859 (2 Nov 2026), Harley's decision (KB 0aa5b516d6a44405; he accepts
     the compliance risk): the full-screen gate becomes a COMPACT,
     NON-BLOCKING bottom banner.
       - one short line + "Customise" link + a close "×".
       - × = ACCEPT ALL (exactly the signal Accept sent before).
       - Customise opens the preferences panel: category toggles, "Save",
         and "Reject all".
       - no scroll lock, no focus trap, no backdrop. It hides while the bag
         is open and sits ABOVE the PDP sticky bar (assets/hl-consent-gate.css),
         so it never covers the bag, the Checkout button or Add to Bag.
       - shown once, remembered (storedChoice / Shopify's own consent).
     The consent itself is written exactly as before: record() below. */
  function build() {
    if (document.getElementById('hl-consent-gate')) return;
    if (storedChoice() || shopifyDecided()) return;

    var gate = document.createElement('div');
    gate.className = 'hl-cgate hl-cgate--bar';
    gate.id = 'hl-consent-gate';
    gate.setAttribute('role', 'region');
    gate.setAttribute('aria-label', 'Cookie notice');

    var policy = window.hlConsentPolicyUrl || '/policies/privacy-policy';

    var CATS = [
      { key: 'essential',   label: 'Essential',       note: 'Keeps your bag and checkout working. Always on.', locked: true },
      { key: 'analytics',   label: 'Analytics',       note: 'Tells us which pieces people look at, so we buy better.' },
      { key: 'marketing',   label: 'Marketing',       note: 'Lets us show you our pieces elsewhere.' },
      { key: 'preferences', label: 'Personalisation', note: 'Remembers your size, your country and what you have viewed.' }
    ];
    function rowHtml(c) {
      var id = 'hl-cgate-cat-' + c.key;
      return '<div class="hl-cgate__cat">' +
        '<div class="hl-cgate__cat-text">' +
          '<label class="hl-cgate__cat-label" for="' + id + '">' + c.label + '</label>' +
          '<p class="hl-cgate__cat-note">' + c.note + '</p>' +
        '</div>' +
        '<span class="hl-cgate__switch' + (c.locked ? ' is-locked' : '') + '">' +
          '<input type="checkbox" id="' + id + '" data-hl-cat="' + c.key + '"' +
            (c.locked ? ' checked disabled' : ' checked') + '>' +
          '<span class="hl-cgate__switch-track" aria-hidden="true"></span>' +
        '</span>' +
      '</div>';
    }

    gate.innerHTML =
      '<div class="hl-cgate__bar" data-hl-step="choose">' +
        '<p class="hl-cgate__line" id="hl-cgate-body">We use cookies to give you a better visit. ' +
          '<a href="' + policy + '" target="_blank" rel="noopener noreferrer">Privacy</a>' +
          ' &middot; <button type="button" class="hl-cgate__link" data-hl-step-to="customise">Customise</button></p>' +
        '<button type="button" class="hl-cgate__x" data-hl-consent="accept" aria-label="Close and accept cookies">&times;</button>' +
      '</div>' +
      '<div class="hl-cgate__prefs" data-hl-step="customise" hidden>' +
        '<div class="hl-cgate__prefs-head">' +
          '<p class="hl-cgate__title" id="hl-cgate-title">Cookie preferences</p>' +
          '<button type="button" class="hl-cgate__x" data-hl-step-to="choose" aria-label="Back">&times;</button>' +
        '</div>' +
        '<div class="hl-cgate__cats">' + CATS.map(rowHtml).join('') + '</div>' +
        '<div class="hl-cgate__actions">' +
          '<button type="button" class="hl-cgate__btn hl-cgate__btn--primary" data-hl-save="1">Save preferences</button>' +
          '<button type="button" class="hl-cgate__btn hl-cgate__btn--secondary" data-hl-consent="reject">Reject all</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(gate);
    document.documentElement.classList.add('hl-cgate-open');

    var steps = {};
    [].forEach.call(gate.querySelectorAll('[data-hl-step]'), function (st) {
      steps[st.getAttribute('data-hl-step')] = st;
    });
    function goTo(name) {
      steps.choose.hidden = (name !== 'choose');
      steps.customise.hidden = (name !== 'customise');
      gate.classList.toggle('is-prefs', name === 'customise');
      var f = (name === 'customise' ? steps.customise : steps.choose).querySelector('input:not([disabled]),button');
      if (f && f.focus) f.focus();
    }

    function close(choice, cats) {
      record(choice, cats);
      document.documentElement.classList.remove('hl-cgate-open');
      if (gate.parentNode) gate.parentNode.removeChild(gate);
    }

    gate.addEventListener('click', function (e) {
      var t = e.target && e.target.closest
        ? e.target.closest('[data-hl-consent],[data-hl-step-to],[data-hl-save]') : null;
      if (!t) return;
      if (t.hasAttribute('data-hl-step-to')) { goTo(t.getAttribute('data-hl-step-to')); return; }
      if (t.hasAttribute('data-hl-save')) {
        var cats = { analytics: false, marketing: false, preferences: false, sale_of_data: false };
        [].forEach.call(gate.querySelectorAll('[data-hl-cat]'), function (i) {
          var k = i.getAttribute('data-hl-cat');
          if (k !== 'essential') cats[k] = i.checked;
        });
        cats.sale_of_data = cats.marketing;
        close('custom', cats);
        return;
      }
      close(t.getAttribute('data-hl-consent'));
    });
    gate.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !steps.customise.hidden) { e.preventDefault(); goTo('choose'); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
